<template>
  <m-dialog
    ref="dlgSetJadwalGrup"
    @save="save"
    :title="
      settingJadwal && settingJadwal.settingJadwal_id
        ? 'Ubah Grup'
        : 'Tambah Grup'
    "
  >
    <v-container>
      <v-row row wrap justify="center" align="center">
        <v-col cols="12" sm="10" md="10" lg="10" xl="10">
          <v-form @submit.prevent data-vv-scope="form" lazy-validation>
            <v-layout wrap>
              <v-flex xs12 md12 lg12>
                <v-stepper v-model="e1">
                  <v-stepper-header>
                    <v-stepper-step :complete="e1 > 1" step="1"
                      >Pilih Grup</v-stepper-step
                    >
                    <v-divider></v-divider>

                    <v-stepper-step :complete="e1 > 2" step="2"
                      >Pilih Jam Kerja</v-stepper-step
                    >

                    <v-divider></v-divider>

                    <v-stepper-step step="3">Verifikasi</v-stepper-step>
                  </v-stepper-header>

                  <v-stepper-items>
                    <v-stepper-content step="1">
                      <v-layout wrap justify-center>
                        <v-flex xs12>
                          <label class="caption mb-2 primary--text"
                            >Pilih Grup</label
                          >
                          <v-select
                            dense
                            single-line
                            outlined
                            :items="grup"
                            name="Grup Anggota"
                            label="Pilih Grup"
                            multiple
                            v-model="settingJadwal.grup"
                            hint="Grup Anggota"
                            data-vv-name="grup"
                            data-vv-as="grup"
                            :return-object="true"
                            v-validate="'required'"
                            item-text="nama"
                            item-value="grup_id"
                            :error-messages="errors.collect('form.grup')"
                          ></v-select>
                        </v-flex>
                        <v-flex>
                          <!-- <v-btn depressed outlined @click="e1 = 1">Kembali</v-btn> -->
                          <v-btn
                            depressed
                            color="primary"
                            @click="validasiStep(2)"
                            >Lanjut</v-btn
                          >
                        </v-flex>
                      </v-layout>
                    </v-stepper-content>
                    <v-stepper-content step="2">
                      <v-layout column wrap justify-center>
                        <v-flex xs6 sm6 md6 lg6 xl6>
                          <label class="caption mb-2 primary--text"
                            >Jam Kerja</label
                          >
                          <v-select
                            dense
                            single-line
                            outlined
                            :items="jamKerjas"
                            name="jam kerja"
                            label="Pilih Jam Kerja"
                            v-model="settingJadwal.jam_kerja"
                            :return-object="true"
                            hint="Jam Kerja"
                            data-vv-name="jam_kerja"
                            data-vv-as="jam_kerja"
                            item-text="nama"
                            item-value="konfigurasi_jadwal_id"
                            :error-messages="errors.collect('form.jam_kerja')"
                          ></v-select>
                        </v-flex>
                        <v-flex>
                          <!-- <v-btn depressed color="primary" @click="e1 = 2">Lanjut</v-btn> -->
                          <v-btn depressed @click="e1 = 1">Kembali</v-btn>&nbsp;
                          <v-btn depressed color="primary" @click="e1 = 3"
                            >Lanjut</v-btn
                          >
                        </v-flex>
                      </v-layout>
                    </v-stepper-content>
                    <v-stepper-content step="3">
                      <v-layout wrap justify-center>
                        <v-flex xs12 v-if="settingJadwal.jam_kerja">
                          <p class="subtitle-1 font-weight-bold">
                            Jam Kerja : {{ settingJadwal.jam_kerja.nama }}
                          </p>
                          <p class="subtitle-1 font-weight-bold">
                            Masa Berlaku:
                            {{ settingJadwal.jam_kerja.tgl_berlaku | toSDN }}
                            s/d
                            {{ settingJadwal.jam_kerja.tgl_berakhir | toSDN }}
                          </p>
                          <p class="subtitle-1 font-weight-bold">
                            Grup :
                            <v-chip
                              outlined
                              acolor="orange"
                              v-for="item in settingJadwal.grup"
                              :key="item.grup_id"
                              >{{ item.nama }}</v-chip
                            >
                          </p>
                          <p class="subtitle-1 font-weight-bold">
                            Apakah Anda akan memproses Jadwal Kerja sesuai
                            konfigurasi yang Anda lakukan?
                          </p>
                        </v-flex>
                        <v-flex xs12>
                          <v-btn depressed color="primary" @click="save">
                            <v-icon>mdi-shield-check</v-icon>Ya </v-btn
                          >&nbsp;
                          <v-btn depressed color="error" @click="e1 = 2">
                            <v-icon>mdi-arrow-left</v-icon>Batal
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-stepper-content>
                  </v-stepper-items>
                </v-stepper>
              </v-flex>
            </v-layout>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </m-dialog>
</template>

<script>
export default {
  $_veeValidate: {
    validator: "new"
  },

  data() {
    return {
      settingJadwal: {},
      e1: 0,
      items: [],
      grup: [],
      selection: [],
      itemSelected: [],
      selectAll: true,
      jamKerjas: [],
      jamKerja: null,
      page: null,
      cp: 1,
      headers: [
        { text: "ID", align: "left", value: "user_id" },
        { text: "Nama", align: "left", value: "nama" }
      ]
    };
  },
  methods: {
    // eslint-disable-next-line
    openSetJadwal(obj) {
      this.$validator.reset();
      this.e1 = 1;
      this.getJamKerja();
      this.getGrup();
      this.settingJadwal.grup = [];
      this.settingJadwal.jam_kerja = obj;
      return this.$refs.dlgSetJadwalGrup.open();
    },
    validasiStep(step) {
      this.$validator.validateAll("form").then(res => {
        if (!res) return Promise.reject();
        this.e1 = step;
        return this.e1;
      });
    },
    save() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          const objGroup = {
            group: this.settingJadwal.grup,
            konfigurasi_jadwal_id: this.settingJadwal.jam_kerja
              .konfigurasi_jadwal_id,
            kode_organisasi: this.organisasi_id || ''
          };
          return this.$store.dispatch("jadwalKerja/formGroup", objGroup);
        })
        .then(res => {
          this.$refs.dlgSetJadwalGrup.resolve();
          this.$router.push({ name: "jamKerja" });
          return res;
        })
        .catch(e => e);
    },
    getGrup() {
      this.$store
        .dispatch("grup/get", { organisasi_id: this.organisasi_id || this.tenant_id })
        .then(res => {
          this.grup = res.data.data || res.data;
        })
        .catch(e => e);
    },
    getJamKerja() {
      this.$store
        .dispatch("jamKerja/get", {
          organisasi_id: this.organisasi_id || this.tenant_id
        })
        .then(res => {
          this.jamKerjas = res.data.data;
        });
    }
    // add() {
    //   this.$refs.dlgSetJadwal
    //     .open()
    //     .then(() => {
    //       this.getGrup();
    //       this.getJamKerja();
    //     })
    //     .catch(e => e);
    // },
    // edit(item) {
    //   this.$refs.dlgSetJadwal
    //     .open(item)
    //     .then(() => {
    //       this.getGrup();
    //       this.getJamKerja();
    //     })
    //     .catch(e => e);
    // }
  }
};
</script>
